var _mask, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLightIcnCopy18Fill = function SvgLightIcnCopy18Fill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "light_icn_copy_18_fill_svg__a",
    width: 11,
    height: 13,
    x: 5.054,
    y: 4.136,
    fill: "#000",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.054 4.136h11v13h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.054 13.848c0 .868.69 1.562 1.527 1.562h5.315c.849 0 1.527-.706 1.527-1.562v-7.15c0-.868-.69-1.562-1.527-1.562"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B8C3D0",
    d: "M6.054 13.848c0 .868.69 1.562 1.527 1.562h5.315c.849 0 1.527-.706 1.527-1.562v-7.15c0-.868-.69-1.562-1.527-1.562"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F4F7",
    d: "M5.054 13.848c0 1.403 1.12 2.562 2.527 2.562v-2a.546.546 0 0 1-.527-.562zM7.58 16.41h5.315v-2H7.581zm5.315 0c1.427 0 2.527-1.18 2.527-2.562h-2c0 .33-.257.562-.527.562zm2.527-2.562v-7.15h-2v7.15zm0-7.15c0-1.404-1.12-2.562-2.527-2.562v2c.268 0 .527.23.527.562z",
    mask: "url(#light_icn_copy_18_fill_svg__a)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B8C3D0",
    stroke: "#F0F4F7",
    strokeMiterlimit: 10,
    d: "M10.42 2.079H5.091c-1.13 0-2.027.934-2.027 2.062v7.162c0 1.128.897 2.062 2.027 2.062h5.327c1.13 0 2.027-.934 2.027-2.062V4.14c0-1.128-.896-2.062-2.027-2.062Z"
  })));
};
export default SvgLightIcnCopy18Fill;